import React, { useState, useEffect } from 'react';
import { GithubPicker } from 'react-color';
import styled from 'styled-components';
import colors from '../../../constants/colors';

export default function ColorPicker({
  bgColor,
  disabled,
  handleChange,
  paletteColors = colors.paletteColors,
}) {
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState(bgColor);

  useEffect(() => {
    setColor(bgColor);
  }, [bgColor]);

  const changeColor = (v) => {
    setColor(v);
    setOpen(false);
    handleChange(v);
  };

  return (
    <Container>
      <div className={`btn btn-xs btn-outline-light ${disabled && 'disabled'}`}>
        <span
          className="colorSwitch-picker"
          style={{ background: paletteColors[color] }}
          onClick={() => {
            if (!disabled) setOpen(!open);
          }}
        />
      </div>
      {open && !disabled && (
        <div style={{ position: 'absolute', zIndex: '999' }}>
          <GithubPicker
            style={{ wrap: { boxSizing: 'none' } }}
            color={paletteColors[color]}
            colors={paletteColors}
            onChange={(v) => changeColor(paletteColors.indexOf(v?.hex?.toUpperCase()))}
          />
        </div>
      )}
    </Container>
  );
}

const Container = styled.div`
  position: 'relative';
  display: 'inline-block';

  .colorSwitch-picker {
    display: block;
    width: 32px;
    height: 28px;
    margin: 2px 0;
    border: #ddd solid 1px;
  }
  .github-picker {
    box-sizing: initial;
    width: 125px !important;
  }
`;
